import '../styles/action-buttons.scss'
import type { FC } from 'react'
import { SearchButton } from '@/features/layout/header/subcomponents/searchButton/SearchButton'
import { SignInButton } from '@/features/layout/header/subcomponents/signInButton/SignInButton'
import { SitePickerButton } from '@/features/layout/header/subcomponents/sitePickerButton/SitePickerButton'

export const ActionButtons: FC = () => {
    return (
        <span className="action-buttons">
            <SitePickerButton />
            <SearchButton />
            <SignInButton />
        </span>
    )
}
